import { Injectable } from '@angular/core';
import { Subscription, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private count = 0;
  private isLoading = false;
  private hideDelaySub?: Subscription;

  constructor() {}

  public show() {
    this.count = Math.max(0, this.count + 1);
    if (this.hideDelaySub) {
      this.hideDelaySub.unsubscribe();
      this.hideDelaySub = undefined;
    }
    if (this.count > 0) {
      this.presentLoading();
    }
  }

  public hide() {
    this.count = Math.max(0, this.count - 1);
    if (this.count > 0 || !this.isLoading) {
      return;
    }
    if (this.hideDelaySub) {
      this.hideDelaySub.unsubscribe();
    }
    this.hideDelaySub = timer(500).subscribe(() => {
      if (this.count < 1) {
        this.closeLoading();
      }
    });
  }

  private presentLoading() {
    this.isLoading = true;
    const progressBar = document.getElementById('mainProgressBar') as HTMLElement;
    if (progressBar) {
      progressBar.style.display = 'block';
    }
  }

  private closeLoading() {
    this.isLoading = false;
    const progressBar = document.getElementById('mainProgressBar') as HTMLElement;
    if (progressBar) {
      progressBar.style.display = 'none';
    }
  }
}
